import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full gap-y-6" }
const _hoisted_2 = { class: "flex gap-x-3 items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-md text-gray-900" }, "Do Not Disturb", -1)
const _hoisted_4 = {
  key: 0,
  class: "flex w-full gap-x-4 gap-y-2 flex-grow items-center"
}

import { watch } from "vue"
import { useWorkflowStore } from "@/stores/workflow"
import { DoNotDisturbPeriod } from "@/shared/models/workflow"
import GgmsInput from "@/components/GgmsInput.vue"
import GgmsDropdown from "@/components/GgmsDropdown.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'DoNotDisturbComponent',
  setup(__props) {

const workflowStore = useWorkflowStore()

const options = [
    { label: "Day(s)", value: DoNotDisturbPeriod.day },
    { label: "Week(s)", value: DoNotDisturbPeriod.week },
    { label: "Month(s)", value: DoNotDisturbPeriod.month },
    { label: "Year(s)", value: DoNotDisturbPeriod.year },
]

function enable() {
    if (workflowStore.doNotDisturb.isEnabled) {
        workflowStore.doNotDisturb.number = 1
        workflowStore.doNotDisturb.period = DoNotDisturbPeriod.day
    }
}

watch(
    () => workflowStore.doNotDisturb,
    () => {
        workflowStore.areButtonDisabled =
            workflowStore.doNotDisturb.isEnabled &&
            (!workflowStore.doNotDisturb.number || workflowStore.doNotDisturb.number === 0) &&
            !workflowStore.doNotDisturb.period
    },
    { deep: true }
)

return (_ctx: any,_cache: any) => {
  const _component_InputSwitch = _resolveComponent("InputSwitch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_InputSwitch, {
        modelValue: _unref(workflowStore).doNotDisturb.isEnabled,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(workflowStore).doNotDisturb.isEnabled) = $event)),
        onChange: enable
      }, null, 8, ["modelValue"])
    ]),
    (_unref(workflowStore).doNotDisturb.isEnabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(GgmsInput, {
            modelValue: _unref(workflowStore).doNotDisturb.number,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(workflowStore).doNotDisturb.number) = $event)),
            class: "w-full"
          }, null, 8, ["modelValue"]),
          _createVNode(GgmsDropdown, {
            modelValue: _unref(workflowStore).doNotDisturb.period,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(workflowStore).doNotDisturb.period) = $event)),
            options: options,
            "option-value": "value",
            "option-label": "label",
            class: "w-full"
          }, null, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})